import { buildBarSeries } from '../bar/series';
import { CORNER_RADIUS } from '../shared/barRadius';
import type { ChartDataItem } from '../types';
import type { SpendingTrendBarChartConfig } from './types';

const rescaleRadius = (radius: unknown, to: number): unknown =>
  Array.isArray(radius) ? radius.map((r) => (r === CORNER_RADIUS ? to : r)) : radius === CORNER_RADIUS ? to : radius;

/**
 * Wraps buildBarSeries as-is, adding two opt-in extras: rescaled corner radius (drawer uses 6px)
 * and hover color (buildBarSeries disables emphasis by default). Pass-through when neither applies.
 */
export const buildSpendingTrendSeries = (
  data: ChartDataItem[],
  orderedFields: string[],
  categoryField: string,
  config: SpendingTrendBarChartConfig,
) => {
  const { barCornerRadius = CORNER_RADIUS, hoverColorOverrides } = config;
  const series = buildBarSeries(data, orderedFields, categoryField, config);

  const needsRadiusRescale = barCornerRadius !== CORNER_RADIUS;
  const hoverColors = hoverColorOverrides ?? [];
  const needsHoverColor = hoverColors.length > 0;
  if (!needsRadiusRescale && !needsHoverColor) return series;

  return series.map((s, idx) => ({
    ...s,
    ...(needsRadiusRescale && {
      data: (s.data as Array<Record<string, unknown>>).map((item) => ({
        ...item,
        itemStyle: {
          ...(item.itemStyle as Record<string, unknown>),
          borderRadius: rescaleRadius((item.itemStyle as Record<string, unknown>)?.borderRadius, barCornerRadius),
        },
      })),
    }),
    ...(needsHoverColor && {
      emphasis: {
        itemStyle: {
          color: hoverColors[idx % hoverColors.length],
          opacity: 1,
        },
      },
    }),
  }));
};
